<template>
  <section :dir="props.controls.rtl ? 'rtl' : null">
    <ui-select
      :options="props.options"
      :class="{ 'demo-select-custom-colors': props.controls.customColor }"
      :disabled="props.controls.disabled"
      :inside="props.inside"
      fullwidth
      data-test="dropdown"
      @selected="onSelected($event)"
    >
    </ui-select>
  </section>
</template>

<script setup>
const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  controls: {
    type: Object,
    default: () => ({
      rtl: false,
      customColor: false,
      disabled: false,
    }),
  },
  // Renders the dropdown menu as a fixed, full-viewport overlay (with scrim)
  // instead of an absolutely-positioned menu. Required when the dropdown lives
  // inside a scrollable/overflow-clipped container such as the side sheet,
  // otherwise the menu is clipped and unusable (notably on mobile).
  inside: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['selected']);

const onSelected = (selected) => {
  emit('selected', selected.value);
};
</script>

<style scoped lang="scss">
:deep() {
  .mdc-select--filled {
    .mdc-line-ripple {
      &:after {
        border-bottom-color: theme('colors.grey.base');
      }
    }
  }

  .mdc-select:not(.mdc-select--disabled).mdc-select--focused
    .mdc-select__dropdown-icon {
    fill: theme('colors.text.link-on-light') !important;
  }

  .mdc-select__menu {
    z-index: 999;
  }

  .mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected {
    background-color: theme('colors.background.base') !important;
  }
}
</style>
